import { formatChatTime } from '@/shared/model/chat.model';
const AVATAR_VARIANTS = ['', 'purple', 'orange', 'green'];
export function roomAvatarVariant(roomId) {
    let h = 0;
    for (let i = 0; i < roomId.length; i++) {
        h = roomId.charCodeAt(i) + ((h << 5) - h);
    }
    return AVATAR_VARIANTS[Math.abs(h) % AVATAR_VARIANTS.length];
}
/** BEM modifier for sidebar avatars, e.g. `crm-chat-full-page__avatar--purple`. */
export function sidebarAvatarClass(variant) {
    return variant ? `crm-chat-full-page__avatar--${variant}` : '';
}
/** BEM modifier for message-row mini avatars. */
export function miniAvatarClass(variant) {
    return variant ? `crm-chat-full-page__mini-avatar--${variant}` : '';
}
export function roomInitials(roomId) {
    const cleaned = roomId.replace(/^#/, '').trim();
    if (!cleaned)
        return '?';
    const parts = cleaned.split(/[\s_-]+/).filter(Boolean);
    if (parts.length >= 2)
        return (parts[0][0] + parts[1][0]).toUpperCase();
    return cleaned.slice(0, 2).toUpperCase();
}
export function userInitials(username) {
    const p = username.trim().split(/[\s.@]+/).filter(Boolean);
    if (p.length >= 2)
        return (p[0][0] + p[1][0]).toUpperCase();
    const u = username.trim();
    return u.slice(0, 2).toUpperCase() || '?';
}
export function getLastMessagePreview(entries) {
    if (!entries?.length)
        return null;
    for (let i = entries.length - 1; i >= 0; i--) {
        const e = entries[i];
        if (e.type === 'message') {
            return { preview: e.message.content, time: formatChatTime(e.message.timestamp) };
        }
    }
    return null;
}
export function filterChatRoomsByGroup(rooms, group) {
    const active = rooms.filter((r) => !r.archived);
    if (group === 'all')
        return [...active];
    if (group === 'groups')
        return active.filter((r) => r.type === 'PUBLIC' || r.type === 'PRIVATE');
    if (group === 'direct')
        return active.filter((r) => r.type === 'DM');
    return active.filter((r) => {
        const hay = `${r.name} ${r.roomKey}`.toLowerCase();
        return hay.includes(group);
    });
}
